module.exports = __webpack_public_path__ + "4e33f3c04cd65095a02b59bd6213430a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-photo/img/large_720x720_icon.png
// module id = 747
// module chunks = 0